import React, {useEffect, useState} from 'react';
import {Checkbox, Select, Space} from 'antd';
import {useAppDispatch, useAppSelector} from "common/hook";
import {fetchCourses} from "features/model/service/courses/fetchCourses";
import './style.css';
import {ReactComponent as SelectArrayIcon} from '../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIcon} from '../../../../../assets/i/arrow-up-icon.svg';
import {ReactComponent as CloseFormIcon} from '../../../../../assets/form/close-form.svg';
import {CheckboxChangeEvent} from "antd/es/checkbox";

interface CustomSelectOptionProps {
    label: string;
    value: number;
    checked: boolean;
    onChange: (event: CheckboxChangeEvent) => void;
}

const CustomSelectOption: React.FC<CustomSelectOptionProps> = ({ label, value, checked, onChange }) => {
    const checkboxId = `checkbox-${value}`;
    const handleLabelClick = (e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => {
        e.preventDefault();
        onChange(e as unknown as CheckboxChangeEvent);
    };

    return (
        <label className="custom-checkbox-label" htmlFor={checkboxId} onClick={handleLabelClick}>
            <Checkbox
                id={checkboxId}
                className="custom-checkbox"
                type="checkbox"
                value={value}
                checked={checked}
                onChange={onChange}
            />
            {label}
        </label>
    );
};

export const SelectMode: React.FC = () => {
    const dispatch = useAppDispatch();
    const categories = useAppSelector((state) => state.courses.courseData.categories);
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const [open, setOpen] = useState<boolean>(false);
    const shouldAllowClear = selectedCategories.length >= 3;




    useEffect(() => {
        dispatch(fetchCourses({}));
    }, [dispatch]);

    const handleChange = (value: number[]) => {
        setSelectedCategories(value);
        if (value.length === 0) {
            dispatch(fetchCourses({}));
        }
    };

    const handleClear = () => {
        setSelectedCategories([]);
        dispatch(fetchCourses({}));
    };

    const handleApply = () => {
        const queryParams = {
            categories: selectedCategories,
        };
        dispatch(fetchCourses(queryParams));
        setOpen(false);
    };


    const customClearIcon = (
        <CloseFormIcon
            onClick={() => {
                handleClear()
            }}
        />
    );

    const options = categories?.map((category) => ({
        label: category.title,
        value: category.id,
        disabled: false,
    }));

    return (
        <div id="select-mode">
            <Space
                direction="vertical"
                className="adaptive-space"
            >
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    onChange={handleChange}
                    maxTagCount="responsive"
                    showSearch={false}
                    filterOption={false}
                    allowClear={shouldAllowClear}
                    clearIcon={customClearIcon}
                    value={selectedCategories}
                    // optionLabelProp="label"
                    open={open}
                    onDropdownVisibleChange={(visible) => setOpen(visible)}
                    placeholder={
                        <span style={{ marginLeft: '20px', color: '#93a9ab', fontSize: '15px' }}>
                            Выберите тип курса
                        </span>
                    }
                    suffixIcon={open ? <ArrowUpIcon /> : <SelectArrayIcon />}
                    dropdownRender={(menu) => (
                        <div>
                            {menu}
                            <div className="filter-btns">
                                <button
                                    onClick={handleClear}
                                    className="js-clear-values"
                                    disabled={selectedCategories.length === 0}
                                >
                                    Очистить
                                </button>
                                <button
                                    disabled={selectedCategories.length === 0}
                                    type="button"
                                    onClick={handleApply}
                                    className="btn small js-apply-filter"
                                    data-filter-box="courses-filtration"
                                >
                                    <span>Применить</span>
                                </button>
                            </div>
                        </div>
                    )}
                >
                    {options?.map((option) => (
                        <Select.Option
                            key={`option-${option.value}`}
                            value={option.value}
                        >
                            <CustomSelectOption
                                label={option.label}
                                value={option.value}
                                checked={selectedCategories.includes(option.value)}
                                onChange={(e) => {}}
                            />
                        </Select.Option>
                    ))}
                </Select>
            </Space>
        </div>
    );
};




